<template>
  <div
    class="table-chart"
    v-bar="{preventParentScroll: true, scrollThrottle: 5, draggerThrottle: 5}"
  >
    <div class="vuebar">
      <div v-if="chartData.rows.length > 0">
        <div
          v-for="(item, index) in tableRows"
          :key="index"
          class="data-row grid between cross-center"
        >
          <div class="grid cross-center">
            <div class="data-img" v-if="img">
              <img class="processing-icon" :src="processingIcon(item.id)" />
            </div>
            <div class="data-img" v-if="card">
              <span class="card-type" :class="cardClass(item.id)"></span>
            </div>
            <div class="data-name">{{ item.code || item.state_id }}</div>
          </div>
          <div class="data-count">
            {{ item.count }}
            <span class="data-percent">({{ percentage(item.count).toFixed(2) }}%)</span>
          </div>
          <div class="u-16 ver-padding-5 data-progress" v-if="hideProgress">
            <el-progress
              :show-text="false"
              :stroke-width="3"
              :percentage="percentage(item.count)"
              :color="color"
            ></el-progress>
          </div>
        </div>
        <div class="u-16 data-row" v-if="!isFull && chartData.rows.length > 8">
          <AppButton
            class="u-16 show-full"
            type="border"
            size="small"
            @click.prevent="isFull = !isFull"
          >Загрузить еще</AppButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { mapGetters } from "vuex";
import Vuebar from "vuebar";
Vue.use(Vuebar);
export default {
  name: "tableChart",
  props: ["chartData", "img", "color", "card"],
  data() {
    return {
      isFull: false
    };
  },
  methods: {
    percentage(count) {
      let summ = this.chartData.rows.reduce((a, b) => a + b.count, 0);
      let perc = (count / summ) * 100;
      return Math.round(perc * 100) / 100;
    },
    hideProgress() {
      let el = document.getElementsByClassName("data-progress");
      let w = el.offsetWidth;
      if (w < 100) return false;
      else true;
    }
  },
  computed: {
    ...mapGetters(["processingIcon", "cardName", "cardClass"]),
    tableRows() {
      let rows = this.chartData.rows;
      let filter = rows.filter(
        (el, i) => el.code != "" && (this.isFull || i < 8)
      );
      return filter;
    }
  }
};
</script>

<style lang="sass">
  
</style>